import Vue from 'vue';

import Loading from './Loading';
import ServerInfo from './ServerInfo';

import ToolTip from './ToolTip';
import ContentTitle from './ContentTitle';
import GroupSelector from './GroupSelector';
import CheckAllHeader from './CheckAllHeader';

import PagingTable from './tables/Paging';
import ScrollTable from './tables/Scroll';
import PlainTable from './tables/Plain';
import CheckAllButton from './tables/CheckAllButton';

import DatePicker from './datepickers/DatePicker';
import DateTimePicker from './datepickers/DateTimePicker';
import TimePicker from './datepickers/TimePicker';
import PeriodPicker from './datepickers/PeriodPicker';
import WeekPicker from './datepickers/WeekPicker';
import MonthPicker from './datepickers/MonthPicker';
import QuarterPicker from './datepickers/QuarterPicker';
import YearPicker from './datepickers/YearPicker';

import HelpButton from './help/HelpButton';
import ExcelDownloadButton from './ExcelDownloadButton';

import Swal from 'sweetalert2';

Vue.component('Loading', Loading);
Vue.component('ServerInfo', ServerInfo);

Vue.component('ToolTip', ToolTip);
Vue.component('ContentTitle', ContentTitle);
Vue.component('GroupSelector', GroupSelector);
Vue.component('CheckAllHeader', CheckAllHeader);

Vue.component('PagingTable', PagingTable);
Vue.component('ScrollTable', ScrollTable);
Vue.component('PlainTable', PlainTable);
Vue.component('CheckAllButton', CheckAllButton);

Vue.component('DatePicker', DatePicker);
Vue.component('DateTimePicker', DateTimePicker);
Vue.component('TimePicker', TimePicker);
Vue.component('PeriodPicker', PeriodPicker);
Vue.component('WeekPicker', WeekPicker);
Vue.component('MonthPicker', MonthPicker);
Vue.component('QuarterPicker', QuarterPicker);
Vue.component('YearPicker', YearPicker);

Vue.component('HelpButton', HelpButton);
Vue.component('ExcelDownloadButton', ExcelDownloadButton);

const showButtonDialog = (msg) => {
  Swal.fire({
    html: '<pre>' + msg + '</pre>',
    title: '',
    icon: 'info',
    confirmButtonText: '확인',
  });
};

const showConfirmDialog = (msg) => {
  return new Promise(async (resolve, reject) => {
    const isConfirmed = await Swal.fire({
      html: '<pre>' + msg + '</pre>',
      title: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    }).then((result) => {
      return result.isConfirmed;
    });
    if (isConfirmed) {
      resolve();
    }
  });
};

// Chrome 패치 대응 - confirm, alert 모달로 변경
// cross origin iframe 내에서 confirm, alert
// https://www.chromestatus.com/feature/5148698084376576
window.confirm = (msg) => {
  return showConfirmDialog(msg);
};

window.alert = (msg) => {
  showButtonDialog(msg);
};
